/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 4/28/2023
 */
import React, { useState, useEffect } from "react";
import { Card, CardActions, Button, CardHeader, Tooltip,Grow,Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Helpers from "../../utils/Helpers";
import Avatar from "@mui/material/Avatar";
import PermissionsModal from "./PermissionsModal";
import api from "../../services/AuthApi";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import CircularProgress from "@mui/material/CircularProgress";
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling";

const PendingRoleItem = (props) => {
  const [permModalOpen, setPermModalOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [isBtnLoading, setIsBtnLoading] = useState(false);

  useEffect(() => {
    if (props?.perms.length == 0) {
      setBtnDisable(true);
    } else {
      setBtnDisable(false);
    }
  }, []);

  const handleClear = () => {
    setTimeout(() => {
      props.setIsSuccess(false);
      props.setSuccessMessages([""]);
      props.setIserror(false);
      props.setErrorMessages([]);
      props.setIsPendingChange(true);
    }, 5000);
  };

  const handleAccept = (approveId) => {
    setIsBtnLoading(true);
    const payload = {
      approvedIdList: [
        {
          approvedId: approveId,
        },
      ],
    };

    api
      .patch("/role/permissions", payload)
      .then((res) => {
        setIsBtnLoading(false);
        props.setIsSuccess(true);
        props.setSuccessMessages([res.data?.description]);
        props.setErrorMessages([]);
        props.setIserror(false);
        handleClear();
      })
      .catch((error) => {
        setIsBtnLoading(false);
        console.log(error);
        props.setIsSuccess(false);
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        );
        handleClear();
      });
  };

  const handleReject = (approveId) => {
    setIsBtnLoading(true);
    const payload = {
      rejectedIdList: [
        {
          rejectedId: approveId,
        },
      ],
    };

    api
      .patch("/role/permissions", payload)
      .then((res) => {
        setIsBtnLoading(false);
        props.setIsSuccess(true);
        props.setSuccessMessages([res.data?.description]);
        props.setErrorMessages([]);
        props.setIserror(false);
        handleClear();
      })
      .catch((error) => {
        setIsBtnLoading(false);
        console.log(error);
        props.setIsSuccess(false);
        RequestErrorHandeling(
          error,
          props.setIserror,
          props.setErrorMessages,
          props.setIserrorShow,
          props.setIsUnauhtError
        );
        handleClear();
      });
  };

  return (
    <div>
      <Grow in={true} className="transformOrigin" timeout={1000}>
        <Card sx={{ maxWidth: 385, width: 380, boxShadow: 3 }}>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: "red"[500] }} aria-label="recipe">
                {Helpers.firstLetterFormat(
                  Helpers.underscoreRoleFormat(props.roleTitle)
                )}
              </Avatar>
            }
            title={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  
                }}
              >
                <Tooltip title={Helpers.underscoreRoleFormat(props.roleTitle)}>
                  <h5
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                      cursor:"pointer"
                    }}
                  >
                    {Helpers.underscoreRoleFormat(props.roleTitle)}
                  </h5>
                </Tooltip>
              </Box>
            }
            subheader={Helpers.underscoreRoleFormat(props.action)}
            action={
              <div>
                {isBtnLoading === false ? (
                  <div>
                    <Tooltip title="Accept">
                      <IconButton
                        onClick={() => handleAccept(props?.approveId)}
                        aria-label="Accept"
                      >
                        <PlaylistAddCheckIcon
                          fontSize="large"
                          color="success"
                        />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Reject">
                      <IconButton
                        onClick={() => handleReject(props?.approveId)}
                        aria-label="Reject"
                      >
                        <PlaylistRemoveIcon fontSize="large" color="error" />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  <CircularProgress
                    sx={{ marginTop: "10px", marginRight: "25px" }}
                    size={20}
                  />
                )}
              </div>
            }
          />
          <br />
          <CardActions>
            <Button
              disabled={btnDisable}
              size="small"
              onClick={() => setPermModalOpen(true)}
            >
              Show Permissions
            </Button>
          </CardActions>
        </Card>
      </Grow>
      <PermissionsModal
        open={permModalOpen}
        onClose={() => setPermModalOpen(false)}
        permissions={props.perms}
        isPending={true}
      />
    </div>
  )
};
export default PendingRoleItem;
